import axios from "axios";
export var Network;
(function (Network) {
    const origin = `${process.env.API_HOST}public/live/v1/`;
    const plusOrigin = `${process.env.API_HOST}plus/live/v1/`;
    async function get(path) {
        const data = await (await axios.get(`${origin}${path}`)).data;
        return data;
    }
    Network.get = get;
    async function plusGet(path, token) {
        const data = await (await axios.get(`${plusOrigin}${path}`, { headers: { Authorization: `Bearer ${token}` } })).data;
        return data;
    }
    Network.plusGet = plusGet;
})(Network || (Network = {}));
